import PurchaseOrderCreateContainer from "@legacy/purchase_orders/PurchaseOrderCreateContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { NavTopBar } from "@organisms"

import { AppFrame } from "@templates"

import { PURCHASE_ORDER_ROUTES } from "@routes/purchase-orders"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function PurchaseOrderEdit() {
    const purchaseOrderId = window.PURCHASE_ORDER_ID
    const isDraft = window.PURCHASE_ORDER_IS_DRAFT

    const [detailsRoute] = useSlugExtractor([PURCHASE_ORDER_ROUTES.DETAILS], purchaseOrderId)
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const detailsBackDestination = hasPermission("purchase_orders_view_permission", PERMISSION_LEVEL.FULL)
        ? detailsRoute
        : undefined

    return (
        <AppFrame.Root navigationType="inner">
            <NavTopBar.Root>
                <NavTopBar.Header>
                    <NavTopBar.NavTopBarHeaderStart>
                        <NavTopBar.PageInnerTitle
                            label={isDraft ? "New Purchase Order" : "Edit Purchase Order"}
                            backDestination={detailsBackDestination}
                        />
                    </NavTopBar.NavTopBarHeaderStart>
                </NavTopBar.Header>
            </NavTopBar.Root>
            <AppFrame.PageContent>
                <PurchaseOrderCreateContainer formMode="EDIT_PURCHASE_ORDER" addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
